

function zoomIn(event) {
	var element = $(".gallery__zoom-wrapper");
	var img = $(".gallery__image");

	$('.gallery__zoom-wrapper').addClass('gallery__zoom-wrapper--active');

	var posX = event.offsetX ? (event.offsetX) : event.pageX - img.offsetLeft;
	var posY = event.offsetY ? (event.offsetY) : event.pageY - img.offsetTop;
	element[0].style.backgroundPosition=(-posX)+"px "+(-posY)+"px";
}

function zoomOut() {
	$('.gallery__zoom-wrapper').removeClass('gallery__zoom-wrapper--active');
}